import { HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { yellow } from 'bold-ui/lib/styles/colors'
import { Box } from 'components/Box'
import ContextualHelpIconAlert from 'images/contextual-help/contextual-help-alert.webp'
import React from 'react'

export interface ContextualHelpProps {
  children: React.ReactNode
  title: string
  color?: string
  image?: string
}

export function ContextualHelp(props: Readonly<ContextualHelpProps>) {
  const { children, title, color = yellow.c80, image = ContextualHelpIconAlert } = props
  const theme = useTheme()
  const styles = createStyles(theme, color)

  return (
    <VFlow vSpacing={0}>
      <Box style={styles.topBar} />
      <Box style={styles.content}>
        <HFlow hSpacing={1} alignItems='center'>
          <img src={image} alt='Aviso' style={styles.image} />
          <VFlow vSpacing={0.25}>
            <Text fontWeight='bold'>{title}</Text>
            {children}
          </VFlow>
        </HFlow>
      </Box>
    </VFlow>
  )
}

const createStyles = (theme: Theme, color?: string) => ({
  topBar: {
    backgroundColor: color,
    height: '0.75rem',
    borderRadius: '0.75rem 0.75rem 0 0',
    padding: 0,
    borderBottom: 0,
    borderTop: 0,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0 0 0.75rem 0.75rem ',
    borderTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
  image: {
    maxHeight: '100px',
    maxWidth: '100%',
    paddingBottom: '0.25rem',
  },
})
